module.exports = __webpack_public_path__ + "static/media/3.d15b0b5d.jpg";